import React from "react";

const AboutSection = () => {
  return (
    <>
      <h2>About Section</h2>
    </>
  );
};

export default AboutSection;
